export default import.meta.ROLLDOWN_FILE_URL_GLuR8l9euBvDzzUiMJ3n1g